<template>
  <div :class="{
    'wgt-member-info': true,
  }">
    <el-image :src="value.backgroundImg.imgUrl" mode="aspectFill" class="cover-bg" />
    <div class="wgt-bd" :style="contentStyle">
      <el-image class="avatar"
        src="http://prd-aarminp-image.oss-cn-beijing.aliyuncs.com/xcximage/member/avatar_default.png" />
      <div>
        <div class="name" :style="colorStyle">微信用户</div>
        <div class="no" :style="colorStyle">
          <span class="integral-num">10000</span>
          <span class="integral">积分</span>
          <span v-if="value.perfectInfo" class="perfect-info" :style="colorStyle">{{ value.perfectInfo }}{{' >'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from './config'
export default {
  name: 'NewMemberInfo',
  wgtName: '会员信息-新',
  wgtDesc: '',
  wgtIcon: 'wgt-member-info',
  wgtType: 3,
  wgtTem: 1,//0代表微信和抖音小程序都可以配置,1代表只能配置微信
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {}
  },
  created() { },
  methods: {},
  computed: {
    contentStyle() {
      const { setupInfo: { top, left }} = this.value
      return {
        top: `${top}px`,
        left: `${left}px`,
      }
    },
    colorStyle() {
      const { setupInfo: { color }} = this.value
      return {
        color: `${color}`,
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wgt-member-info {
  width: 100%;
  position: relative;
  height: fit-content;
  min-height: 62px;

  .cover-bg {
    width: 100%;
    display: block;
  }

  .wgt-bd {
    display: flex;
    align-items: center;
    position: absolute;

    .avatar {
      width: 46px;
      height: 46px;
      border-radius: 100%;
      margin-right: 10px;
    }


    .name {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0px;
      line-height: 24px;
    }

    .no {

      .integral-num{
        font-size: 19px;
        line-height: 22px;
      }

      .integral{
        font-size: 15px;
        margin-left: 4px;
      }
    }
  }
  .perfect-info{
    margin-left: 8px;
    font-size: 10px;
    color: #D7DEFF;
  }
}
</style>
